import { render, staticRenderFns } from "./HistorialDialog.vue?vue&type=template&id=c1d35b42"
import script from "./HistorialDialog.vue?vue&type=script&lang=js"
export * from "./HistorialDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports